// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  favicon_set: "dev",
  api_url: "https://dev-api.projul.com/",
  // api_url: "https://localhost:5001/",  // Local backend for testing
  website_url: "http://localhost:4400/",
  portal_url: 'https://dev-app.projul.com/',
  mapbox: {
    accessToken: "pk.eyJ1IjoicHJvanVsIiwiYSI6ImNrdGFiNGpsZTFrY3cydnA0aWx4ZzRxcHUifQ.yp04PN1ACdxkynafMxHouw",
  },
  appVersion: '2.9.0010'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
